import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'iv-bag',
  size: 24,
  node: [
    ['path', { d: 'M12 18v2a2 2 0 002 2h6', key: '1pl0l9' }],
    ['path', { d: 'M6 11c.72.5 1.44 1 3 1 3 0 3-2 6-2 1.56 0 2.28.5 3 1', key: 'h3dcr' }],
    [
      'path',
      {
        d: 'M9.293 3c.453 0 .887-.18 1.207-.5s.754-.5 1.207-.5h.586c.453 0 .887.18 1.207.5s.754.5 1.207.5H16a2 2 0 012 2v11a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2z',
        key: 'nsf2p2',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name IvBag
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTh2MmEyIDIgMCAwMDIgMmg2IiAvPgogIDxwYXRoIGQ9Ik02IDExYy43Mi41IDEuNDQgMSAzIDEgMyAwIDMtMiA2LTIgMS41NiAwIDIuMjguNSAzIDEiIC8+CiAgPHBhdGggZD0iTTkuMjkzIDNjLjQ1MyAwIC44ODctLjE4IDEuMjA3LS41cy43NTQtLjUgMS4yMDctLjVoLjU4NmMuNDUzIDAgLjg4Ny4xOCAxLjIwNy41cy43NTQuNSAxLjIwNy41SDE2YTIgMiAwIDAxMiAydjExYTIgMiAwIDAxLTIgMkg4YTIgMiAwIDAxLTItMlY1YTIgMiAwIDAxMi0yeiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/iv-bag
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const IvBag = createLucideIcon(__iconData);

export default IvBag;
